<template>
  <div class="organization-picker">
    <div class="list-group">
      <template v-if="value">
        <template v-for="(organization, index) in organizations">
          <li :class="activeOrg(organization)"
          :key="index"
          v-if="!value || organization.uuid === value.uuid"
          class="list-group-item">
            <img class="float-right" :class="organization.theme" :src="url + organization.OrganizationLogo.objectKey" height="35"/>
            <label>{{ organization.pageTitle }}</label><br/>
            <span class="small">{{ organization.companyName }} ({{ organization.homePage }})</span>
          </li>
        </template>
      </template>
      <template v-if="!value">
        <li @click="changeOrganization(null)" class="list-group-item" :class="allOrgs">
          <label>All Organisations</label><br/>
          <span class="small">({{ organizations.length }} Organisations)</span>
        </li>
      </template>
    </div>
    <button class="btn btn-sm btn-primary" type="button"
    @click="changingOrganization = true" v-if="!changingOrganization">
      <span class="fa fa-fw fa-sync"></span> Change Organisation
    </button>
    <div class="list-group" v-if="changingOrganization">
      <li @click="changeOrganization(null)" class="list-group-item" :class="allOrgs" v-if="value">
        <label>All Organisations</label><br/>
        <span class="small">({{ organizations.length }} Organisations)</span>
      </li>
      <template v-for="(organization, index) in organizations">
        <li @click="changeOrganization(organization)"
        :class="activeOrg(organization)"
        :key="index"
        v-if="!value || organization.uuid !== value.uuid"
        class="list-group-item">
          <img class="float-right" :class="organization.theme" :src="url + organization.OrganizationLogo.objectKey" height="35"/>
          <label>{{ organization.pageTitle }}</label><br/>
          <span class="small">{{ organization.companyName }} ({{ organization.homePage }})</span>
        </li>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrganizationPicker',
  props: {
    organizations: {
      type: Array
    },
    value: {
      type: [Object, Boolean]
    }
  },
  data () {
    return {
      url: 'https://techcar-dev.s3.amazonaws.com/',
      changingOrganization: false
    }
  },
  computed: {
    allOrgs () {
      return { 'active': !this.value }
    }
  },
  methods: {
    changeOrganization (org) {
      this.changingOrganization = false
      this.$emit('input', org)
    },
    activeOrg (org) {
      return { 'active': this.value && this.value.uuid === org.uuid }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/OrganizationPicker.vue